import { useAnalytics } from '@anchorage/analytics';
import { useAppContext } from 'context/AppContext/AppContext';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import useIsPortoApp from 'utils/useIsPortoApp';

type Props = {
  children: ReactNode;
};

const AnalyticsPageViewTracker = ({ children }: Props) => {
  const { sessionInfo, currentRoute } = useAppContext();
  const { id: sessionId, sessionFormType } = sessionInfo || {};
  const { track } = useAnalytics();
  const isPorto = useIsPortoApp();

  useEffect(() => {
    if (!isPorto) {
      track({
        name: 'navigation:onboarding:page_view',
        data: {
          formType: sessionFormType,
          pageId: currentRoute || '/',
          submissionId: sessionId,
        },
      });
    }
  }, [sessionId, currentRoute, track, sessionFormType, isPorto]);

  return children;
};

export { AnalyticsPageViewTracker };
